import { Component, Input } from '@angular/core';
import { IApplicationDetails } from '../../models/application-details.model';
import {
  getApplicationStateColor,
  getApplicationStateLabel,
} from '../../services/application/application.service';

@Component({
  standalone: false,
  selector: 'irembogov-application-tracker',
  templateUrl: './application-tracker.component.html',
  styleUrls: ['./application-tracker.component.scss'],
})
export class ApplicationTrackerComponent {
  @Input() applicationDetails?: IApplicationDetails;

  getApplicationStatusToLabel(applicationStatus: string): string {
    return getApplicationStateLabel(applicationStatus);
  }

  getApplicationStatusToColor(applicationStatus: string): string {
    return getApplicationStateColor(applicationStatus);
  }
}
